import { useEffect, useState } from 'react'

import Admin from './admin/Admin'
import { clearRedirectFlag, handleCallback, initOidc, isRedirecting } from './oidc'

const App = (): JSX.Element => {
  const [ready, setReady] = useState(false)

  useEffect(() => {
    const search = new URLSearchParams(window.location.search)

    if (search.has('code') && search.has('state')) {
      // OIDC callback — pass undefined (not '') when the URL omits organization so initOidc falls through to localStorage.
      const organization = search.get('organization') || undefined
      initOidc(organization)
      handleCallback()
        .then(() => setReady(true))
        .catch(() => setReady(true))
    } else {
      // Normal page load — clear stale redirect state. Don't pass '' to initOidc (would create a userManager on every /login visit).
      clearRedirectFlag()
      const organization = search.get('organization') || undefined
      initOidc(organization)
      setReady(true)
    }
  }, [])

  if (!ready) {
    return <></>
  }

  return <Admin />
}

export default App
